<checkout-header [host]="host" (back)="back()" (next)="next()"
                 [cart]="cart"
                 [step]="getNextStep()"
                 [canProceed]="form.valid"></checkout-header>

<main class="container">

  <h5 class="mt-3"><i class="fa fa-user"></i>&nbsp;<span i18n>Contact data</span></h5>

  <p i18n>
      Please enter your contact information.
  </p>

  <form class="t4d-form" [formGroup]="form" (ngSubmit)="next()">

    <div class="form-group mt-2">
      <label for="id_name" i18n>Name*</label>
      <input type="text" class="form-control" id="id_name" required autocomplete="name"
             formControlName="name">
    </div>

    <div class="form-group">
      <label for="id_phone"><span i18n>Phone</span><span *ngIf="host.require_delivery_phone">*</span></label>
      <input type="tel" class="form-control" id="id_phone" autocomplete="tel" [required]="host.require_delivery_phone"
             formControlName="phone">
    </div>

    <div class="form-group">
      <label for="id_email"><span i18n>Email address</span><span *ngIf="host.require_delivery_email">*</span></label>
      <input type="email" class="form-control" id="id_email" autocomplete="email"
             formControlName="email" [required]="host.require_delivery_email">
      <small *ngIf="!host.require_delivery_email" id="email_help" class="form-text text-muted"
             i18n>Optional. We'll send an email when your order is done.</small>
    </div>

    <div class="form-group">
      <label for="id_notes" i18n>Notes</label>
      <textarea id="id_notes" class="form-control" rows="2" formControlName="notes" scrollTopOnFocus></textarea>
    </div>

  </form>

  <p class="mt-3" i18n>
    The order won't be sent right away, you can still review it before submitting. Your personal information
    will only be sent to the restaurant, and will never be shared with anyone else.
  </p>

  <div class="row mt-3 mb-5">
    <div class="col-5">
      <button class="btn btn-secondary" (click)="back()"><i class="far fa-arrow-alt-circle-left"></i>&nbsp;<span i18n>Back</span></button>
    </div>
    <div class="col-7 text-right">
      <next-step-button [step]="getNextStep()"
                        [cart]="cart"
                        [enabled]="canProceed()"
                        (next)="next()"></next-step-button>
    </div>
  </div>

</main>
